'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _isNull = require('lodash/isNull');

var _isNull2 = _interopRequireDefault(_isNull);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _EventListReducer = require('./EventListReducer');

var _EventListReducer2 = _interopRequireDefault(_EventListReducer);

var _HTTPEvent = require('./HTTPEvent');

var _HTTPEvent2 = _interopRequireDefault(_HTTPEvent);

var _constants = require('./constants');

var _EventConstants = require('../models/EventConstants');

var _EventConstants2 = _interopRequireDefault(_EventConstants);

var _constants2 = require('../video/constants');

var _HTTPUtils = require('../utils/HTTPUtils');

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IDLE = 'IDLE';
var WS = 'WS';
var HTTP = 'HTTP';

var dmInstance = _DebugManager2.default.dmInstance;

var EventPumpAbstract = function (_EventEmitter) {
  _inherits(EventPumpAbstract, _EventEmitter);

  function EventPumpAbstract(config) {
    var _this2 = this;

    _classCallCheck(this, EventPumpAbstract);

    var _this = _possibleConstructorReturn(this, (EventPumpAbstract.__proto__ || Object.getPrototypeOf(EventPumpAbstract)).call(this));

    _this.dataHandler = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var checkDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var queueSize;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(0, _isEmpty2.default)(data)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!checkDelay) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this.checkDelay(data);

              case 5:
                queueSize = _this.reduceQueue.push(data);


                dmInstance.logMessage([_DebugManager2.default.debugLevel.PUMP], '[EventPumpAbstract] Queue size after data push: ', queueSize);

                if (!_this.reducing) {
                  _context.next = 10;
                  break;
                }

                dmInstance.logMessage([_DebugManager2.default.debugLevel.PUMP], '[EventPumpAbstract] Already reducing - Abort mission');
                return _context.abrupt('return');

              case 10:

                // We're introducing a tiny timeout here to ensure that
                // 'componentUpdate' is not fired many times simultaneously
                // as that causes rendering inefficiencies.. WN-2541.
                // Also need to clone the model here so that redux properly
                // updates state in connected components
                if (!_this.timeoutId) {
                  _this.timeoutId = setTimeout(_this.handleData, 100, (0, _cloneDeep2.default)(_this.controlRoomModel));
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleData = function () {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var updatedModel = model;
      _this.reducing = true;

      var eventList = _this.reduceQueue.shift();

      dmInstance.logMessage([_DebugManager2.default.debugLevel.PUMP], '[EventPumpAbstract] Popping component events off the reducing queue: ', eventList);

      updatedModel = _EventListReducer2.default.reduce(updatedModel, eventList);

      if (!(0, _isEmpty2.default)(_this.reduceQueue)) {
        _this.handleData(updatedModel);
        return;
      }

      clearInterval(_this.timeoutId);
      _this.timeoutId = 0;
      _this.reducing = false;

      if ((0, _isEmpty2.default)(updatedModel.screens)) {
        return;
      }

      dmInstance.logMessage([_DebugManager2.default.debugLevel.PUMP], '[EventPumpAbstract] Processed everything off the queue. Emitting componentUpdate event');

      _this.emit('componentUpdate', updatedModel);
    };

    _this.errorHandler = function (err) {
      _this.pumpStatus = IDLE;
      // err.response is undefined when we have network issues. This is the Axios error object:
      // https://github.com/axios/axios#handling-errors
      if ((0, _isUndefined2.default)(err.response)) {
        _this.emit('connectionError', _this.eventId, _this.accountId);
        _this.stop();

        // notify user we gave up
        _this.store.dispatch({
          type: _HTTPUtils.SERVICE_UNREACHABLE,
          payload: {
            open: true,
            errorMessage: 'Sorry, we are unable to reach the network. Please try again later.'
          }
        });
      }
      throw err;
    };

    _this.checkDelay = function (event) {
      var _ref2 = event && event[0],
          _ref2$payload = _ref2.payload;

      _ref2$payload = _ref2$payload === undefined ? {} : _ref2$payload;
      var type = _ref2$payload.type,
          screenId = _ref2$payload.screenId;
      var _this$controlRoomMode = _this.controlRoomModel.activeAudienceScreenId,
          activeAudienceScreenId = _this$controlRoomMode === undefined ? '' : _this$controlRoomMode;

      var fromLobbyScreen = activeAudienceScreenId && activeAudienceScreenId.includes(_constants.ScreenTypesEnum.LOBBY);
      var toEventScreen = screenId && screenId.includes(_constants.ScreenTypesEnum.EVENT);

      // We only want to delay when the audience is transitioning
      // from the lobby to the event. Here we are checking if we are
      // updating the active screen AND if the active screen is the event screen.
      // This is to bypass the delay when transitioning to the exit screen.
      return new Promise(function (resolve) {
        if (type === _constants.UPDATE_ACTIVE_AUDIENCE_SCREEN && fromLobbyScreen && toEventScreen) {
          return setTimeout(resolve, _EventConstants2.default.START_EVENT_DELAY * 1000, event);
        }
        resolve();
      });
    };

    _this.getCatchUpEvents = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventId, accountId, componentEventHost) {
        var previewToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '00:00:00';
        var eventList;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.areValidParams(eventId, accountId, componentEventHost)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('\n        Parameters not valid\n        eventId: ' + eventId + '\n        accountId: ' + accountId + '\n        componentEventHost: ' + componentEventHost + '\n      ');

              case 2:

                /** 
                 Historically, we set these vars when starting the eventPump (EventPumpProducer.startEventPump) 
                 or starting to poll (EventPumpAudience.startHttpPolling). There have been instances when
                 playback had started and (pumpStatus = PUMP) then attempted upon error all before
                 explicitly calling EventPumpAudience.startHttpPolling to set these vars. Setting
                 earlier in the flow to prevent these vars from being empty
                 https://mediaplatform.atlassian.net/browse/WN-4020
                */

                _this.eventId = eventId;
                _this.accountId = accountId;
                _this.componentEventHost = componentEventHost;

                eventList = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return _this.httpManager.catchUp(eventId, accountId, componentEventHost, previewToken, _this.eventModel ? _this.eventModel.event.status : null, offset);

              case 9:
                eventList = _context2.sent;
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                console.error(_context2.t0);
                throw _context2.t0;

              case 16:

                /** when reset() is called, empty everything out
                 * except for the nextIds so that pollingHandler()
                 * can seamlessly take over from where catchUp()
                 * left off. Otherwise, same events are re-run.
                 */
                _this.httpManager.reset();

                dmInstance.log('[EventPumpAbstract] Total Catchup events received from the back end: ' + eventList.length);

                return _context2.abrupt('return', eventList);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[6, 12]]);
      }));

      return function (_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.reduceEvents = function (eventList) {
      return _EventListReducer2.default.reduce(_this.controlRoomModel, eventList);
    };

    _this.post = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(metadata, data, eventHost) {
        var inBand = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.t0 = _this.pumpStatus;
                _context3.next = _context3.t0 === WS ? 4 : 7;
                break;

              case 4:
                _context3.next = 6;
                return _this.wsManager.postEvent(metadata, data, inBand);

              case 6:
                return _context3.abrupt('return', _context3.sent);

              case 7:
                _context3.next = 9;
                return _this.httpManager.postEvent(metadata, data, eventHost, inBand);

              case 9:
                return _context3.abrupt('return', _context3.sent);

              case 10:
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t1 = _context3['catch'](0);
                throw _context3.t1;

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 12]]);
      }));

      return function (_x9, _x10, _x11) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.config = _extends({
      isProducer: true
    }, config);

    _this.httpManager = new _HTTPEvent2.default(_this.dataHandler, _this.errorHandler, config);

    _this.pumpStatus = IDLE;

    _this.reduceQueue = [];
    _this.reducing = false;

    _this.store = null;

    _this.accountId = null;
    _this.eventId = null;
    _this.lastInBandEventId = null;
    return _this;
  }

  _createClass(EventPumpAbstract, [{
    key: 'setStore',
    value: function setStore(store) {
      this.store = store;
      this.httpManager.setStore(store);
    }
  }, {
    key: 'areValidParams',
    value: function areValidParams() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      return !params.some(function (param) {
        return (0, _isNull2.default)(param) || (0, _isEmpty2.default)(param) || (0, _isUndefined2.default)(param);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.reduceQueue = [];
      this.httpManager.close();
      this.pumpStatus = IDLE;
    }
  }, {
    key: 'initiateVideoPlayer',
    value: function initiateVideoPlayer(eventId, vbiAccountId, userId, videoId, videoConfig, smartPathUrls, vbiConfig, type, hasPreviewToken, authParams) {
      var _this3 = this;

      var presentationType = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';

      var retObj = void 0;

      if (this.eventModel && !presentationType) {
        presentationType = this.eventModel.event.status === _constants.EventStatusEnum.SCHEDULED || this.eventModel.event.status === _constants.EventStatusEnum.RUNNING ? _constants2.PresentationTypes.LIVE : _constants2.PresentationTypes.ARCHIVE;
      }

      retObj = this.videoManager.constructPlayer(videoId, videoConfig, smartPathUrls, vbiConfig, eventId, vbiAccountId, userId, type, hasPreviewToken, presentationType, authParams);

      if ((0, _isUndefined2.default)(retObj)) return null;

      retObj.promise.then(function (player) {
        // we need to clear out components and their data on a seek
        player.on("seeking", function (evt) {
          /*
            Should only reset components during ARCHIVE. There are times
            when the `seeking` event is triggered during a live event that 
            is not from an explicit user action. (i.e, after playback buffering).
          */
          if (presentationType === _constants2.PresentationTypes.ARCHIVE) {
            this.controlRoomModel.resetComponents = true;
          }
        }.bind(_this3));
      }).catch(function (error) {});
      return retObj;
    }
  }, {
    key: 'controlRoomModel',
    get: function get() {
      return this.store.getState().controlRoom;
    }

    /**
     * The control room and audience apps currently store event details for the current event in different places.
     * We can look to fix that in the future when we look into refactoring/decoupling the event pump code.
     * This function only works for the audience application. Producer needs to override.
     */

  }, {
    key: 'eventModel',
    get: function get() {
      return this.store.getState().event;
    }
  }, {
    key: 'status',
    get: function get() {
      return this.pumpStatus;
    }
  }]);

  return EventPumpAbstract;
}(_events2.default);

exports.default = EventPumpAbstract;